module.exports = __webpack_public_path__ + "img/NewPin.5719260a.svg";